import gql from 'graphql-tag'
import { connect } from 'react-redux'
import history from 'browserHistory'
import RoutesHelper from 'helpers/RoutesHelper'
import { compose, withState } from 'recompose'

import { dataFetched, makesQueries, makesMutations } from 'data/graphql'
import { publicChannelAttrsFragment } from 'remote/channels'
import { closeActiveModal } from 'data/ui/actions'

export const showPublicChannel = gql`
  query ShowPublicChannel($publicShareToken: ID!) {
    showPublicChannel(publicShareToken: $publicShareToken) {
      ...publicChannelAttrs
    }
  }
  ${publicChannelAttrsFragment}
`
const cloneChannel = gql`
  mutation CloneChannel(
    $publicShareToken: String!
    $type: String!
    $userIds: [ID]
    $name: String!
  ) {
    cloneChannel(
      publicShareToken: $publicShareToken
      type: $type
      userIds: $userIds
      name: $name
    )
  }
`

export const providesPublicChannelQuery = compose(
  withState('publicChannelName', 'setPublicChannelName'),
  withState('publicChannelFetchError', 'setPublicChannelFetchError'),
  makesQueries({
    query: showPublicChannel,
    mapPropsToVariables: ({ publicShareToken }) => ({ publicShareToken }),
    getOnResultFromProps: ({ setPublicChannelName }) => ({ result, meta }) => {
      setPublicChannelName(result.data.showPublicChannel.name)
    },
    getOnErrorFromProps: ({ setPublicChannelFetchError }) => ({ error }) => {
      setPublicChannelFetchError(error)
    },
  })
)

export const providesChannelMutations = compose(
  connect(
    null,
    {
      dataFetched,
      closeActiveModal,
    }
  ),
  makesMutations({
    query: cloneChannel,
    mutationPropName: 'cloneChannel',
    getOnResultFromProps: ({ closeActiveModal }) => ({ result }) => {
      history.push(
        RoutesHelper.noteChannelIndex({
          channelId: result.data.cloneChannel,
        })
      )
      closeActiveModal()
    },
  })
)
